/**
 * UserAgent から LINE アプリでのアクセスかどうかを判定
 */
export const isLineApp = (): boolean => {
  const userAgent = navigator.userAgent;
  // LINE の UA は "Line/x.y.z" のようなトークンを含む
  return /\bLine\//i.test(userAgent);
};